import Navbar from '../../components/feature/Navbar';
import SeoHead from '../../components/feature/SeoHead';
import ProjectHero from './components/ProjectHero';
import FacilityReuse from './components/FacilityReuse';
import AquacultureSystem from './components/AquacultureSystem';
import EmploymentCreation from './components/EmploymentCreation';
import WorkLiveIntegration from './components/WorkLiveIntegration';
import EconomicRevitalization from './components/EconomicRevitalization';
import Footer from '../../components/feature/Footer';

const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) ?? '';

const projectJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'プロジェクト | 株式会社C.GREEN | 廃校活用・循環型陸上養殖',
  url: `${siteUrl}/project`,
  description:
    '廃校施設を活用した循環型陸上養殖プロジェクトの詳細をご紹介。施設再利用・養殖システム・雇用創出・地域経済活性化の取り組みを解説します。',
  inLanguage: 'ja',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'プロジェクト', item: `${siteUrl}/project` },
    ],
  },
};

export default function ProjectPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="プロジェクト | 株式会社C.GREEN | 廃校活用・循環型陸上養殖"
        description="廃校施設を活用した循環型陸上養殖プロジェクトの詳細をご紹介。施設再利用・養殖システム・雇用創出・地域経済活性化の取り組みを解説します。"
        keywords="廃校活用プロジェクト,循環型陸上養殖,施設再利用,雇用創出,地域経済活性化,C.GREENプロジェクト"
        canonicalPath="/project"
        jsonLd={projectJsonLd}
      />
      <Navbar />
      <ProjectHero />
      <FacilityReuse />
      <AquacultureSystem />
      <EmploymentCreation />
      <WorkLiveIntegration />
      <EconomicRevitalization />
      <Footer />
    </div>
  );
}
